import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, RouteComponentProps, Switch } from 'react-router';
import { PageNotFound } from '../../shop/PageNotFound';
import { LCProductDetailReadPage } from './product/read/LCProductDetailReadPage';
import { YourTitlesPage } from './yourtitles/YourTitlesPage';
import { LocalContentCollectionPage } from './collection/LocalContentCollectionPage';
import { LCProductDetailEditPage } from './product/edit/LCProductDetailEditPage';
import { LCProductDetailNewPage } from './product/create/LCProductDetailNewPage';
import { CheckRequiredSpoc, SpocRequiredFor } from '../../shared/common/CheckRequiredSpoc/CheckRequiredSpoc';
import { PerformersPage } from './performer/PerformersPage';

const LocalContentRouteSwitch: FC<RouteComponentProps> = ({ match }) => (
    <Switch>
        <Redirect from={match.path} to={`${match.url}/collection`} exact={true} />
        <Route exact={true} path={`${match.path}/products`} component={YourTitlesPage} />
        <Route exact={true} path={`${match.path}/products/new`} component={LCProductDetailNewPage} />
        <Route
            exact={true}
            path={`${match.path}/products/:id`}
            render={(props: RouteComponentProps<{ readonly id: string }>) => {
                return (
                    <CheckRequiredSpoc type={SpocRequiredFor.LOCAL_CONTENT_PRODUCT} id={props.match.params.id}>
                        <LCProductDetailReadPage />
                    </CheckRequiredSpoc>
                );
            }}
        />
        <Route
            exact={true}
            path={`${match.path}/products/:id/edit`}
            render={(props: RouteComponentProps<{ readonly id: string }>) => {
                return (
                    <CheckRequiredSpoc type={SpocRequiredFor.LOCAL_CONTENT_PRODUCT} id={props.match.params.id}>
                        <LCProductDetailEditPage />
                    </CheckRequiredSpoc>
                );
            }}
        />
        <Route exact path={`${match.path}/performers`} component={PerformersPage} />
        <Route exact path={`${match.path}/collection`} component={LocalContentCollectionPage} />
        <Route component={PageNotFound} />
    </Switch>
);

export default LocalContentRouteSwitch;
